(function () {
    'use strict';

    angular
        .module('blocks.validation')
        .directive('validationMessage', validationMessage);

    /* @ngInject */
    function validationMessage() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/blocks/validation/validation.html',
            scope: { options: '=validationMessage' },
            Controller: controller
        };
        return directive;

        function controller() {
        }
    }
})();
